import React, { useState } from 'react';
import { top15FoodBeverageRECCs } from '../../../data/assessmentResults/top15FoodBeverageRECCs';
import { reccImplementationData } from '../../../data/assessmentResults/reccImplementationData';
import { ImplementationAccordion } from '../Components/ImplementationAccordion';

/**
 * Implementation Guide Tab Component
 */
export const ImplementationGuideTab = ({ recommendations = [] }) => {
  const safeRecommendations = recommendations || [];
  const [expandedRecc, setExpandedRecc] = useState(null);

  const toggleExpansion = (reccCode) => {
    setExpandedRecc(expandedRecc === reccCode ? null : reccCode);
  };

  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-gray-800 rounded-xl p-6 border border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-xl font-bold text-gray-900 dark:text-white">Complete ARC Implementation Guides</h3>
          <div className="text-sm text-gray-600 dark:text-gray-400">
            {top15FoodBeverageRECCs.length} recommendations with detailed implementation guides
          </div>
        </div>

        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Each recommendation includes detailed implementation levers, technical specifications, cost analysis, and risk mitigation strategies. Click "View Details" to expand the full implementation guide.
        </p>

        {/* Recommendations Accordion */}
        <div className="space-y-4">
          {top15FoodBeverageRECCs.map((rec, index) => {
            const arcCode = rec.arc_code;
            const implementationData = reccImplementationData[arcCode] || reccImplementationData["2.4231"];
            const isExpanded = expandedRecc === arcCode;

            return (
              <ImplementationAccordion
                key={index}
                recc={rec}
                implementationData={implementationData}
                isExpanded={isExpanded}
                onToggle={() => toggleExpansion(arcCode)}
              />
            );
          })}
        </div>

        {/* Professional Analysis Complete Badge */}
        <div className="bg-gradient-to-r from-emerald-50 to-blue-50 dark:from-emerald-900/30 dark:to-blue-900/30 rounded-lg p-6 border border-emerald-200 dark:border-emerald-700 mt-8">
          <div className="text-center">
            <h4 className="font-bold text-gray-900 dark:text-white mb-2">
              ✓ Complete ARC Implementation Guides for All {top15FoodBeverageRECCs.length} Recommendations
            </h4>
            <p className="text-gray-600 dark:text-gray-400 mb-4">
              Each recommendation includes detailed implementation levers, technical specifications,
              cost analysis, risk mitigation strategies, and phased implementation approaches based on real IAC assessment data.
            </p>
            <div className="bg-emerald-600 dark:bg-emerald-700 text-white px-8 py-3 rounded-lg font-semibold inline-block">
              All Professional Implementation Guides Included
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

